import { render, staticRenderFns } from "./SettlementTransactionView.vue?vue&type=template&id=4367e07d&scoped=true"
import script from "./SettlementTransactionView.vue?vue&type=script&lang=js"
export * from "./SettlementTransactionView.vue?vue&type=script&lang=js"
import style0 from "./SettlementTransactionView.vue?vue&type=style&index=0&id=4367e07d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4367e07d",
  null
  
)

export default component.exports